export const Contact = (props) => {

  return (
    <div>
      <div id='contact'>
        <div className='container'>
          <div className='col-md-12'>
            <div className='row'>
              <div className='social'>
                <ul>
                  <li>
                    <a href={props.data ? props.data.twitter : '/'}>
                      <i className='fab fa-twitter'></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.telegram : '/'}>
                      <i className='fab fa-telegram'></i>
                    </a>
                  </li>
                </ul>
                <hr></hr>
                Token contract address <a id="contractaddress" href="https://bscscan.com/address/0xa400f832C0a924DEcAD4d298edE04A8C6D71153D">0xa400f832C0a924DEcAD4d298edE04A8C6D71153D</a>
                <br></br>
                Official email address iqtestcoin@gmail.com
                <br></br>
                <a className="btn btn-custom btn-lg" href="https://pancakeswap.finance/swap?outputCurrency=0xa400f832C0a924DEcAD4d298edE04A8C6D71153D">Buy</a>
                <a className="btn btn-custom btn-lg btn-chart" href="https://www.dextools.io/app/pancakeswap/pair-explorer/0x3f792b4735505333ec587bbb60fa4e2419cd053c">Chart</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
